import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})
export class GameComponent implements OnInit, OnDestroy {

  private sub: any;

  game:any;

  details:any;

  displayGalleria = false;

  imgIndex = 0;

  inter = 2500;

  papers:any;

  gameInCart:any;

  text:any;

  showPass = false;

  constructor(public api:ApiService, private route: ActivatedRoute,private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {

      this.game = this.api.games.find( item => item.Id == params['id']);

      if(!this.game){
        let game = this.api.games.find( item => item.id_item == params['id']);
        if(game)
          this.api.goTo("/game/"+game.Id);
        return false;
      }

      if(this.game && this.game.idInCart){
        this.gameInCart = this.api.order.prods.find(item=>item.id === this.game.idInCart);
      }else{
        this.game.quantity = this.game.step ? this.game.step : 1;
      }

      this.api.postEncrypted("site=syncItem",{id:this.game.id_item}).then((res:any)=>{
        this.details = res;
        this.game.imgs = (this.details.bunny_images).filter((key) => key.indexOf('logo') === -1);
        this.game.logo = this.details.bunny_images.find((key) => key.indexOf('logo') !== -1);
        console.log(this.game.logo);
        if(this.game.imgs.length === 1)
          this.inter = 0;

        if(this.details.presentation_video != null){
          if(this.details.presentation_video.indexOf('youtu.be') > -1){
            this.details.presentation_video = this.details.presentation_video.replace('youtu.be/','youtube.com/embed/');
          }else if(this.details.presentation_video.indexOf('watch?v=') > -1){
            this.details.presentation_video = this.details.presentation_video.replace('watch?v=','embed/');
          }else{
            this.details.presentation_video = null;
          }
        }
        if(this.details.strong_points != null){
          this.details.strong_points = ("• "+this.details.strong_points.replaceAll("- ","\n")
            .replaceAll("- ","\n")
            .replaceAll("\n۰","\n")
            .replaceAll("\n","\n• "))
          .replaceAll(/•(\s*)•/g,"•").trim();
          if(this.details.strong_points.slice(-1) == "•")
            this.details.strong_points = this.details.strong_points.slice(0,-1);

        }

      });
      this.api.post("pro=getPress",{name_item:this.game.name_item,name:this.game.name}).then((res:any)=>{
        this.papers = res;
      });
      if(parseInt(this.game.RealStock) < 1 || parseInt(this.game.RealStock) < parseFloat(this.game.StockToOrderThreshold))
        this.game.rupture = true;

      return true;
    });
    


  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  addToCart(){
    this.api.addToCart(this.game);
    this.gameInCart = this.api.order.prods.find(item=>item.id === this.game.idInCart);
  }


  showGalleria(id){
    this.imgIndex = this.game.imgs.findIndex(item => item == id) || 0; 
    this.displayGalleria = true;
  }

  download(id){
    this.api.get("media=forceDownload&id_dropbox="+id).then((res:any)=>{
      window.open(res.link, "_blank");
    });
  }

  errorPass = false;
  
  downloadPhotos(pass){
    if(pass == "visuelsblackrockgames" || this.api.pro === true){
      // Construire l'URL de téléchargement
      const downloadUrl = `${this.api.url}media=downloadFromBunny&folder=${this.game.Id}`;      
      // Créer un lien temporaire pour déclencher le téléchargement
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `images_${this.game.Id}_${new Date().toISOString().slice(0,10)}.zip`;
      link.target = '_blank';
      
      // Ajouter le lien au DOM, le cliquer, puis le supprimer
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      this.errorPass = false;
      this.showPass = false;
      
      // Optionnel : afficher un message de succès
      this.api.success("Téléchargement des images en cours...");
      
    } else {
      this.errorPass = true;
    }
  }

  evalReturn(str){
    str = str.replace("api.selectedProduct","game");
    return eval("`"+str+"`");
  }

  chooseOffer(offer){
    let o = Object.assign({}, offer);
    this.api.addToCart(this.game);
    this.gameInCart = this.api.order.prods.find(item=>item.id === this.game.idInCart);
    o.acceptedForProds.push(this.gameInCart.Id);
    if(o.baseQty < 1 && o.field != null){
      o.baseQty = parseInt(this.gameInCart[o.field]);
      console.log(o.baseQty);
    }
    this.gameInCart.quantity = parseInt(o.baseQty);
    this.api.changeQty(this.gameInCart);
  }

  isFav(){
    if(this.api.favs && this.api.favs.findIndex(item=>item.ItemId == this.game.Id) > -1)
      return true;
    return false;
  }

  refresh(){
    this.api.post("SPDO=select",{database:'favorite',where:"CustomerId = '"+this.api.user.Id+"'"}).then((res:any)=>{
      this.api.favs = res.data;
    });
  }

  setFavorite(){
    if(this.isFav()){
      this.api.post("SPDO=delete",{database:'favorite',where:{ItemId:this.game.Id,CustomerId:this.api.user.Id}}).then((res:any)=>{
        this.api.success("Supprimé de vos favoris.");
        this.refresh();
      });
    }else{
      this.api.post("SPDO=insert",{database:'favorite',data:{ItemId:this.game.Id,CustomerId:this.api.user.Id}}).then((res:any)=>{
        this.api.success("Ajouté à vos favoris.");
        this.refresh();
      });
    }
  }
}
